(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-in-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOne(wrapper) {
    if (!wrapper || wrapper.dataset.newinInit === '1') return;
    wrapper.dataset.newinInit = '1';

    var sectionId = wrapper.getAttribute('data-newin-section');
    var tabs = wrapper.querySelectorAll('.newin-tab');
    var panels = wrapper.querySelectorAll('.newin-panel');
    var viewAll = wrapper.querySelector('#newin-viewall-' + sectionId);

    function activateTab(tab) {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('is-active');
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      var targetId = tab.getAttribute('data-tab-target');
      var panel = wrapper.querySelector('#' + targetId);
      if (panel) panel.classList.add('is-active');

      if (viewAll) {
        var url = tab.getAttribute('data-collection-url');
        if (url && url.length) {
          viewAll.href = url;
          viewAll.style.display = '';
        } else {
          viewAll.style.display = 'none';
        }
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        activateTab(tab);
      });
    });

    if (tabs.length) activateTab(tabs[0]);
  }

  function initAll() {
    document
      .querySelectorAll('.newin-wrapper[data-newin-section]')
      .forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support éditeur Shopify (sections rechargées)
  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      var wrapper = event.target.querySelector('.newin-wrapper[data-newin-section]');
      initOne(wrapper);
    } else {
      initAll();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
